import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Server Side Rendering",
  "menu": "Guides",
  "route": "/guides/ssr",
  "description": "Learn how to use components-extra inside modern web frameworks."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Components-extra and Server Side Rendering`}</h1>
    <h2>{`Gatsby.js`}</h2>
    <p>{`All components of `}<strong parentName="p">{`components-extra`}</strong>{` are Server-Side-Rendering friendly, so you can totaly integrate them
in your SSR app.`}</p>
    <p>{`If you are using the awesome framework `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`Gatsby.js`}</a>{` (if you are not, you should definitely try it!), you will need to add
two plugins in your `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{` file to make `}<strong parentName="p">{`components-extra`}</strong>{` work smoothly:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-styled-components/"
        }}>{`gatsby-plugin-styled-components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-material-ui/"
        }}>{`gatsby-plugin-material-ui`}</a></li>
    </ul>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Those are not required to make your app compile correctly, however you might experience some display issues if you don't
use them.`}</p>
    </blockquote>
    <h2>{`Next.js`}</h2>
    <p>{`In order to use `}<strong parentName="p">{`components-extra`}</strong>{` with `}<a parentName="p" {...{
        "href": "https://nextjs.org/"
      }}>{`next.js`}</a>{`, there are a couple of steps to follow:`}</p>
    <ul>
      <li parentName="ul">{`Add `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/next-transpile-modules"
        }}>{`next-transpile-modules`}</a>{` in your next.js config to transpile both Material-UI & components-extra:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// next.config.js
const withTM = require("next-transpile-modules")([
  "@material-ui/core",
  "components-extra"
]); // pass the modules you would like to see transpiled

module.exports = withTM();
`}</code></pre>
    <ul>
      <li parentName="ul">{`Inject `}<inlineCode parentName="li">{`styled-components`}</inlineCode>{` styles in the `}<inlineCode parentName="li">{`<Head>`}</inlineCode>{` of your pages: see `}<a parentName="li" {...{
          "href": "https://styled-components.com/docs/advanced#nextjs"
        }}>{`https://styled-components.com/docs/advanced#nextjs`}</a>{`.`}</li>
      <li parentName="ul">{`Add a `}<inlineCode parentName="li">{`babelrc`}</inlineCode>{` config to handle `}<inlineCode parentName="li">{`styled-components`}</inlineCode>{` in SSR:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  "presets": [
    "next/babel"
  ],
  "plugins": [
    [
      "styled-components",
      {
        "ssr": true
      }
    ]
  ]
}
`}</code></pre>
    <p>{`And that should be it. You can find a working integration on the following codesandbox:`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/comp-extra-testing-npzn7"
      }}>{`https://codesandbox.io/s/comp-extra-testing-npzn7`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      